
import React from "react"

import Layout2 from "../components/layout"
import SEO from "../components/seo"
import App from "../components/appStartkit";
import { Breadcrumb } from "../components/globals/breadcrumb";


const IndexPage = () => (
  <Layout2>
        <Breadcrumb category={["nyheter", "nyheter"]}  page={["Dålig andedräkt", "daligandedrakt"]}/>    
     <SEO title="Andedräkt" description="Dålig andedräkt" keywords={[`Fräsch`, `Andedräkt`, `Munhygien`, `Vita tänder`, `Tandblekning` ]}/>
     <section className="section-metoder">
     <main>
       <h1 class="welcome">Sex olika orsaker till dålig andedräkt</h1>
       <p class="text-center">
       Ifall du lider av dålig andedräkt och din andedräkt luktar illa, kan det kännas pinsamt och obekvämt i sociala situationer eller när du kommer nära någon. Det är därför det är så viktigt att förstå de bakomliggande orsakerna till dålig andedräkt. 
       Här har vi listat sex möjliga orsaker till dålig andedräkt och vad du kan göra åt problemen.</p>
       <h3 class="welcome">1. Du tar inte hand om dina tänder tillräckligt bra</h3>
       <p class="text-center">
       Bakterier bildas konstant på, runt omkring och emellan dina tänder och det kan vara orsaken till dålig andedräkt. När bakterier bryter ner matpartiklar i din mun kan det bildas en illaluktande gas som gör att din andedräkt luktar illa. Det bästa sättet att undvika detta är att borsta tänderna två gånger dagligen med en fluortandkräm och använda tandtråd för att avlägsna bakterier och mat som fastnat på svåråtkomliga ställen mellan dina tänder.</p>
       <h3 class="welcome">2. Du är på väg att få en tandsköttssjukdom</h3>
       <p class="text-center">
       Dålig andedräkt kan vara ett tidigt tecken på tandköttssjukdom, då uppbyggnaden av bakterier längs med tandköttskanten kan orsaka dålig andedräkt. Ifall plack inte avlägsnas kan det leda till blödande och svullet tandkött som båda är symptom på gingivit (tandköttsinflammation). Ifall det lämnas obehandlat, kan det leda till mer allvarliga former av tandköttssjukdom.
</p><p class="text-center">
För att förebygga tandköttsinflammation, borsta två gånger dagligen med en fluortandkräm som parodontax tandkräm som är 4 gånger så effektiv att ta bort huvudorsaken till blödande tandkött jämfört med en vanlig tandkräm*.</p>
<h3 class="welcome">3. Vad du äter och dricker</h3>
<p class="text-center">
Ifall du äter mat med stark lukt såsom vitlök, lök och kryddor eller drycker som kaffe och alkohol kan det temporärt leda till dålig andedräkt. Bästa sättet att få ett stopp på det är att undvika den här typen av mat eller dryck.</p>
<h3 class="welcome">4. Rökning eller snusning</h3>
<p class="text-center">Att röka cigaretter, pipa, använda snus eller tugga tobak kan göra att din andedräkt luktar illa. Det kan också missfärga tänderna och öka risken att du drabbas av en tandköttssjukdom. Sluta röka för en friskare mun, vitare tänder och fräschare andedräkt</p>
<h3 class="welcome">5. Snabbdiet</h3>
<p class="text-center">Fasta och kolhydratfattig kost kan som bieffekt ge dålig andedräkt. Detta beror på att kroppen som en effekt bildar kemikalier som kallas ketoner. De här frigörs i din andedräkt och kan göra att den luktar illa. Den här typen av dålig andedräkt kan endast åtgärdas genom att du ändrar din kost.</p>
<h3 class="welcome">6. Sjukdom</h3>
<p class="text-center">I en del ovanliga fall, kan vissa sjukdomar ge upphov till dålig andedräkt. En är "muntorrhet" eller för att använda den medicinska termen "xerostomia", vilket sker när salivmängden minskas. Det kan ge dålig andedräkt då saliven har som funktion att återfukta munnen och skölja bort de bakterier som kan orsaka dålig andedräkt.
</p><p class="text-center">
Gastrointestinal tillstånd, diabetes, hals och bröstinfektioner kan också orsaka dålig andedräkt. Tala med din tandläkare om du har några funderingar kring detta.
</p><p class="text-center">
 * efter en professionell rengöring och användning två gånger dagligen</p>

</main>
</section>
     <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Startkit</h2>
     <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
    <App />
    </main>
  </section>

  </Layout2>
)

export default IndexPage
